import React, { lazy } from 'react';
const defaultImages = ['https://cdn.magicpatterns.com/uploads/1CgzJQZudYShDrPhtqHFTN/Captura_de_pantalla_2026-05-26_133633.png', 'https://cdn.magicpatterns.com/uploads/ayGCDyCuX5h3JEbUkuM1ZG/Captura_de_pantalla_2026-05-26_122617.png', 'https://cdn.magicpatterns.com/uploads/vLBTP4sbjPTe2GH6kdtzxm/Captura_de_pantalla_2026-05-26_122554.png', 'https://cdn.magicpatterns.com/uploads/5q3WdP4ZTV45te9wJmBQkL/Captura_de_pantalla_2026-05-26_122540.png', 'https://cdn.magicpatterns.com/uploads/bZFXBD7pNTn5zVNS5NvFLi/Captura_de_pantalla_2026-05-26_122516.png'];
type ImageMarqueeProps = {
  images?: string[];
  label?: string;
  reverse?: boolean;
  background?: string;
};
export function ImageMarquee({
  images = defaultImages,
  label = '✨ Diseños reales que vas a poder crear',
  reverse = false,
  background = 'bg-white'
}: ImageMarqueeProps) {
  // Duplicate the array to create a seamless loop
  const loopImages = [...images, ...images];
  const fadeFromColor = background === 'bg-white' ? 'from-white' : 'from-brand-50';
  const fadeToColor = background === 'bg-white' ? 'to-white' : 'to-brand-50';
  return <section className={`${background} py-5 overflow-hidden border-y border-slate-100`} data-id="element-161">
      {label && <div className="max-w-6xl mx-auto px-4 mb-3 text-center" data-id="element-162">
          <p className="text-xs uppercase tracking-wider font-bold text-brand-600" data-id="element-163">
            {label}
          </p>
        </div>}

      <div className="relative w-full overflow-hidden" data-id="element-164">
        {/* Edge fades */}
        <div className={`absolute left-0 top-0 bottom-0 w-12 sm:w-20 bg-gradient-to-r ${fadeFromColor} to-transparent z-10 pointer-events-none`} data-id="element-165" />
        <div className={`absolute right-0 top-0 bottom-0 w-12 sm:w-20 bg-gradient-to-l ${fadeToColor} to-transparent z-10 pointer-events-none`} data-id="element-166" />

        <div className={`flex gap-4 ${reverse ? 'animate-marquee-reverse' : 'animate-marquee'} w-max`} data-id="element-167">
          {loopImages.map((src, idx) => <div key={idx} className="shrink-0 w-40 sm:w-52 md:w-60 aspect-[3/4] rounded-xl overflow-hidden shadow-md border border-slate-100" data-id="element-168">
              <img src={src} alt={`Diseño artesanal ${idx % images.length + 1}`} className="w-full h-full object-cover" loading="lazy" data-id="element-169" />
            </div>)}
        </div>
      </div>
    </section>;
}